import {Role} from 'app/models/PermissionsModel/Role';

export class Operator extends Role {
  constructor() {
    super('operator');

    this.permissions.devices.view = true;
  }
}
